import React from 'react';
import { useTranslation } from 'react-i18next';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
var EditTierButton = function (_a) {
    var className = _a.className, onClick = _a.onClick, isOwner = _a.isOwner;
    var t = useTranslation().t;
    if (!isOwner) {
        return null;
    }
    return (React.createElement(SolidButton, { className: className, size: "large", variant: "main", priority: "primary", onClick: onClick }, t('deviationview.tierCard.cta.edit')));
};
EditTierButton.displayName = 'EditTierButton';
export default EditTierButton;
//# sourceMappingURL=EditTierButton.js.map